// Características da unidade (imóvel) — cadastro + exibição pública

export const PROPERTY_DETAILS_DEFAULTS = {
  // Ambientes
  suite: false,
  serviceRoom: false,
  office: false,
  balcony: false,
  laundryRoom: false,
  closet: false,
  pantry: false,
  maidBathroom: false,

  // Cozinha
  kitchenCabinets: false,
  gourmetKitchen: false,
  serviceArea: false,

  // Mobiliário
  furnished: false,
  semiFurnished: false,
  bedroomCabinets: false,

  // Conforto
  airConditioning: false,
  ceilingFan: false,
  fireplace: false,
  gasShower: false,
  solarHeaterUnit: false,

  // Garagem e circulação
  garage: false,
  coveredGarage: false,
  elevator: false,

  // Área externa e lazer
  pool: false,
  barbecue: false,
  partyArea: false,
  privateGarden: false,
  terrace: false,

  // Tecnologia e segurança
  smart: false,
  smokeAlarm: false,
  unitAlarm: false,

  // Acabamento
  marbleFloor: false,
  woodFloor: false,
  blinds: false,
  showerBox: false,
  bathtub: false,

  // Vistas e diferenciais
  seaView: false,
  lakeView: false,
  mountainView: false,
  duplex: false,
  garden: false,
  petsAllowedUnit: false
};

export const PROPERTY_DETAILS_OTHER_TOPIC = 'Outros';

export const PROPERTY_DETAILS_TOPICS = [
  {
    title: 'Ambientes',
    items: [
      { key: 'suite', label: 'Suíte' },
      { key: 'serviceRoom', label: 'Quarto de serviço' },
      { key: 'office', label: 'Escritório / home office' },
      { key: 'balcony', label: 'Varanda' },
      { key: 'laundryRoom', label: 'Lavanderia' },
      { key: 'closet', label: 'Closet' },
      { key: 'pantry', label: 'Despensa' },
      { key: 'maidBathroom', label: 'Banheiro de serviço' }
    ]
  },
  {
    title: 'Cozinha',
    items: [
      { key: 'kitchenCabinets', label: 'Armários na cozinha' },
      { key: 'gourmetKitchen', label: 'Cozinha gourmet' },
      { key: 'serviceArea', label: 'Área de serviço' }
    ]
  },
  {
    title: 'Mobiliário',
    items: [
      { key: 'furnished', label: 'Mobiliado' },
      { key: 'semiFurnished', label: 'Semi mobiliado' },
      { key: 'bedroomCabinets', label: 'Armários no quarto' }
    ]
  },
  {
    title: 'Conforto',
    items: [
      { key: 'airConditioning', label: 'Ar-condicionado' },
      { key: 'ceilingFan', label: 'Ventilador de teto' },
      { key: 'fireplace', label: 'Lareira' },
      { key: 'gasShower', label: 'Aquecedor a gás' },
      { key: 'solarHeaterUnit', label: 'Aquecedor solar' }
    ]
  },
  {
    title: 'Garagem e circulação',
    items: [
      { key: 'garage', label: 'Garagem' },
      { key: 'coveredGarage', label: 'Garagem coberta' },
      { key: 'elevator', label: 'Elevador' }
    ]
  },
  {
    title: 'Área externa e lazer',
    items: [
      { key: 'pool', label: 'Piscina privativa' },
      { key: 'barbecue', label: 'Churrasqueira' },
      { key: 'partyArea', label: 'Área de festas' },
      { key: 'privateGarden', label: 'Jardim privativo' },
      { key: 'terrace', label: 'Terraço' }
    ]
  },
  {
    title: 'Tecnologia e segurança',
    items: [
      { key: 'smart', label: 'Automação / smart home' },
      { key: 'smokeAlarm', label: 'Detector de fumaça' },
      { key: 'unitAlarm', label: 'Alarme na unidade' }
    ]
  },
  {
    title: 'Acabamento',
    items: [
      { key: 'marbleFloor', label: 'Piso em mármore ou granito' },
      { key: 'woodFloor', label: 'Piso em madeira' },
      { key: 'blinds', label: 'Persianas' },
      { key: 'showerBox', label: 'Box blindex' },
      { key: 'bathtub', label: 'Banheira' }
    ]
  },
  {
    title: 'Vistas e diferenciais',
    items: [
      { key: 'seaView', label: 'Vista para o mar' },
      { key: 'lakeView', label: 'Vista para lago' },
      { key: 'mountainView', label: 'Vista para montanha' },
      { key: 'duplex', label: 'Duplex' },
      { key: 'garden', label: 'Quintal' },
      { key: 'petsAllowedUnit', label: 'Aceita pets' }
    ]
  }
];

/** Mapa chave → rótulo (padrão + uso legado). */
export const PROPERTY_DETAIL_LABELS = PROPERTY_DETAILS_TOPICS.reduce((acc, topic) => {
  topic.items.forEach((item) => {
    acc[item.key] = item.label;
  });
  return acc;
}, {});

export function getPropertyCustomItemKey(id) {
  return `custom_${id}`;
}

export function createPropertyCustomItemId() {
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
}

export function normalizePropertyDetailsCustom(items) {
  if (!Array.isArray(items)) return [];
  return items
    .filter((item) => item && typeof item.id === 'string' && item.id.length > 0)
    .map((item) => ({
      id: item.id,
      topic: typeof item.topic === 'string' && item.topic.trim() ? item.topic.trim() : PROPERTY_DETAILS_OTHER_TOPIC,
      label: typeof item.label === 'string' ? item.label.trim() : ''
    }))
    .filter((item) => item.label.length > 0);
}

export function getCustomPropertyItemsByTopic(customItems, topicTitle) {
  return normalizePropertyDetailsCustom(customItems).filter((item) => item.topic === topicTitle);
}

/**
 * @param {object} details
 * @param {Array} customCatalog
 */
export function getActivePropertyDetailItems(details = {}, customCatalog = []) {
  if (!details || typeof details !== 'object') return [];
  const standard = PROPERTY_DETAILS_TOPICS.flatMap((topic) =>
    topic.items.filter((item) => details[item.key] === true).map((item) => ({ key: item.key, label: item.label }))
  );
  const custom = normalizePropertyDetailsCustom(customCatalog)
    .filter((item) => details[getPropertyCustomItemKey(item.id)] === true)
    .map((item) => ({
      key: getPropertyCustomItemKey(item.id),
      label: item.label
    }));
  return [...standard, ...custom];
}
